/* Copyright (C) Nodeport SA de CV - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by América Mendoza <amendoza@nodeport.co> &
 * Darien Miranda <dmiranda@nodeport.co>
 * September 2026
 */

import React from 'react';
import PropTypes from "prop-types";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import NbioApi from "../../lib/api/NbioApi";
import CardBody from "react-bootstrap/CardBody";
import Card from "react-bootstrap/Card";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import ProgressBar from "react-bootstrap/ProgressBar";


class ProductImporterDataQuality extends React.Component {
    constructor(p) {
        super(p);
        this.state = {
            data: [],
            isLoading: false,
        }
        this.loadDataQuality = this.loadDataQuality.bind(this);
    }
    componentDidMount() {
        this.loadDataQuality();
    }

    loadDataQuality(){
        this.setState({isLoading:true});
        NbioApi.products.getProductsDataQuality().then(res => {
            this.setState({
                data:res.data,
                isLoading:false,
            });
        });
    }

    render() {
        const data =  this.state.data;

        return (
            <Card>
                <CardBody>
                    <Row>
                        <Col sm={4}>
                            <h6 className={'mb-4'}>Datos completos</h6>
                            <div className={'d-flex flex-row align-items-end'}>
                                <h1 className={'mr-2'}>{data.percentageComplete}% </h1>
                                <p>completo</p>
                            </div>
                            <ProgressBar variant={"success"} now={10} />
                            <div className={"my-2 d-flex justify-content-between"}>
                                <span className={'small'}><FontAwesomeIcon icon={'circle'} className={'text-success mr-1'} />{data.totalComplete} completos</span>
                                <span className={'small'}><FontAwesomeIcon icon={'circle'} className={'text-warning mr-1'} />{data.totalIncomplete} incompletos</span>
                            </div>
                            <p className={'small'}>{data.totalIncomplete} de {data.totalProducts} productos que al menos le falta un campo</p>
                        </Col>
                        {/*<Col sm={8} className={"border-start"}>*/}
                        {/*    <h6  className={'text-muted'}>Campos incompletos</h6>*/}
                        {/*</Col>*/}
                    </Row>
                </CardBody>
            </Card>
        )
    }

}

export default ProductImporterDataQuality;

ProductImporterDataQuality.propTypes = {
    onProductSelected: PropTypes.func

}
ProductImporterDataQuality.defaultProps = {
    onProductSelected: () => {}
}
